import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { TextHighlightingSetting } from './../../model/entity/text-highlighting-setting';
import { TextHighlightSettingService } from './../../service/text-highlight-setting-service';
import { Helper } from 'app/common/helper';
import { ScheduleMergeService } from 'app/service/schedule-merge.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogService } from 'app/service/dialog.service';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { GTFSManagerService } from 'app/service/gtfs-manager.service';
import { Constant } from 'app/config/constants';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
@Component({
  selector: 'app-dialog-text-highlighting-setting',
  templateUrl: './dialog-text-highlighting-setting.component.html',
  styleUrls: ['./dialog-text-highlighting-setting.component.scss']
})
/**
 * Dialog Pick color
 */
export class DialogTextHighlightingSettingComponent implements OnInit {
  fontColor: any = '#000000';
  public listData: TextHighlightingSetting[] = Constant.DEFAULT_TEXT_HIGHLIGHTING_SETTING;
  listDataSave: TextHighlightingSetting[] = [];
  listOrigin = ['Suspension', 'Delay', 'Arrival', 'Priority'];
  listActive = [];
  constructor(
    public dialogRef: MatDialogRef<DialogTextHighlightingSettingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private scheduleMergeService: ScheduleMergeService,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private textHighlightSettingService: TextHighlightSettingService,
    private gtfsManagerService: GTFSManagerService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (this.data.isGtfs) {
      this.gtfsManagerService.getAllGtfsTextHighLightSetting().subscribe(data => this.processLoadData(data));
    } else {
      this.textHighlightSettingService.getAllTextHighLightSetting().subscribe(data => this.processLoadData(data));
    }
  }

  processLoadData(data: any) {
    if (!data || !data.length) {
      let listSave = this.listData.map(dataSave => Helper.convertTextHighlightToDB(dataSave));
      if (this.data.isGtfs) {
        this.gtfsManagerService.saveGtfsTextHighlight(listSave).subscribe();
      } else {
        this.scheduleMergeService.saveTextHighlight(listSave).subscribe();
      }

      this.moveElement();
      return;
    }
    this.listData = data.map(d => Helper.convertTextHighlightFromDB(d));
    if (this.listData.length == 5) {
      const highlightSetting = {
        id: 6,
        titleName: 'highlight-setting',
        name: '-1',
        blinking: undefined,
        object: undefined,
        color: undefined,
        isActive: undefined,
        readOnlyName: undefined,
        opacity: undefined
      };
      this.listData.push(highlightSetting);
      let listSave = this.listData.map(dataSave => Helper.convertTextHighlightToDB(dataSave));
      if (this.data.isGtfs) {
        this.gtfsManagerService.saveGtfsTextHighlight(listSave).subscribe();
      } else {
        this.scheduleMergeService.saveTextHighlight(listSave).subscribe();
      }
    }
    let itemSetting = this.listData.find(e => e.titleName == 'highlight-setting');
    if (itemSetting.name != '-1' && this.data.properties.length < +itemSetting.name) {
      this.listData.find(e => e.titleName == 'highlight-setting').name = '-1';
    }
    const names = this.listData.filter(e => e.readOnlyName).map(color => color.name);
    this.listActive = _.cloneDeep(this.listOrigin.filter(e => !names.includes(e)));
    this.moveElement();
  }

  moveElement() {
    const sourceIndex = this.listData.findIndex(item => item.titleName == 'highlight-setting');

    if (sourceIndex !== -1) {
      const elementToMove = this.listData.splice(sourceIndex, 1)[0];
      this.listData.splice(2, 0, elementToMove);
    }
    this.cdr.detectChanges();
  }

  onChangeData(data) {
    const i = this.listData.findIndex(element => element.titleName == data.titleName);
    // if (i == -1) {
    //   this.listDataSave.push(data);
    // } else {
    this.listData[i] = data;
    const names = this.listData.filter(e => e.readOnlyName).map(color => color.name);
    this.listActive = _.cloneDeep(this.listOrigin.filter(e => !names.includes(e)));
    // }
  }

  private showUpdateFail(e?: any): void {
    const errMsg =
      e && e.status === Constant.NETWORK_ERROR_CODE
        ? this.translateService.instant('dialog-error.error-network-api')
        : this.translateService.instant('dialog-api-definition-setting.error');
    this.dialogService.showDialog(DialogMessageComponent, {
      data: {
        title: this.translateService.instant('dialog-error.title'),
        texts: [errMsg]
      }
    });
  }

  onSave() {
    if (!this.checkBlinkingOpacity()) {
      this.dialogService.showDialog(
        DialogConfirmComponent,
        {
          data: {
            text: this.translateService.instant(`dialog-text-highlighting-setting.confirmConflictBlinkingOpacity`),
            button1: this.translateService.instant('timetable-editor.yes'),
            button2: this.translateService.instant('timetable-editor.btn-no')
          }
        },
        result => {
          if (!result) {
            return;
          } else {
            //convert blinking to OFF
            this.convertOffBlinking();
            let listSave = this.listData.map(dataSave => Helper.convertTextHighlightToDB(dataSave));
            if (this.data.isGtfs) {
              this.gtfsManagerService.saveGtfsTextHighlight(listSave).subscribe(
                e => {
                  this.dialogRef.close(<Array<TextHighlightingSetting>>e);
                },
                e => {
                  this.showUpdateFail(e);
                }
              );
            } else {
              this.scheduleMergeService.saveTextHighlight(listSave).subscribe(
                e => {
                  this.dialogRef.close(<Array<TextHighlightingSetting>>e);
                },
                e => {
                  this.showUpdateFail(e);
                }
              );
            }
          }
        }
      );
    } else {
      let listSave = this.listData.map(dataSave => Helper.convertTextHighlightToDB(dataSave));
      if (this.data.isGtfs) {
        this.gtfsManagerService.saveGtfsTextHighlight(listSave).subscribe(
          e => {
            this.dialogRef.close(<Array<TextHighlightingSetting>>e);
          },
          e => {
            this.showUpdateFail(e);
          }
        );
      } else {
        this.scheduleMergeService.saveTextHighlight(listSave).subscribe(
          e => {
            this.dialogRef.close(<Array<TextHighlightingSetting>>e);
          },
          e => {
            this.showUpdateFail(e);
          }
        );
      }
    }
  }
  /**
   * Check Blinking Opacity
   */
  checkBlinkingOpacity(): Boolean {
    let isNotConflictBlinkingOpacity = true;
    for (const data of this.listData) {
      if (data.blinking && data.opacity != 1) {
        isNotConflictBlinkingOpacity = false;
      }
    }
    return isNotConflictBlinkingOpacity;
  }
  convertOffBlinking() {
    for (const data of this.listData) {
      if (data.blinking && data.opacity != 1) {
        data.blinking = false;
      }
    }
  }
}

/**
 * Dialog data
 */
export interface DialogData {
  title: string;
  text: string;
  texts: Array<string>;
  properties: any[];
  isGtfs: boolean;
}
